import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-suo",
  "use": "icon-suo-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-suo\"><path d=\"M573 927.2a32.5 32.4 0 1 0 65 0 32.5 32.4 0 1 0-65 0Z\" fill=\"#4d4d4d\" /><path d=\"M768 448.2H320.1V319.7c0-105.6 86.4-192 192-192s191 86.4 191 192v31.9c0 17.8 15.5 32.2 33.3 32.2s32.3-14.4 32.3-32.2c-0.1-0.6-0.1-1.1-0.1-1.7v-29.6c0-141.1-115.4-256.6-256.5-256.8-141.4-0.1-257 115.4-257 256.8v127.9h-0.1c-70.4 0-128 57.6-128 128v255.1c0 70.4 57.6 128 128 128h218.4c0.7 0 1.4 0.1 2.2 0.1 18 0 32.5-14.5 32.5-32.4s-14.6-32.4-32.5-32.4h-0.1v-0.1H256c-35.2 0-64-28.8-64-64V577c0-35.2 28.8-64 64-64h511c35.2 0 64 28.8 64 64v253.5c0 35.2-28.8 64-64 64H735.7c-18 0-32.5 14.5-32.5 32.4s14.6 32.4 32.5 32.4H768c70.4 0 128-57.6 128-128V576.2c0-70.4-57.6-128-128-128z\" fill=\"#4d4d4d\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/suo.svg
// module id = L/c7
// module chunks = 22